{
  "familyId": "TOPO-KLIMAAT",
  "questions": [
    {
      "id": "TOPO-KLIMAAT-001",
      "familyId": "TOPO-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "interpretatie",
      "subSkill": "klimaat_zones",
      "questionType": "multiple_choice",
      "question": "Welke klimaatzone ligt rond de evenaar?",
      "context": null,
      "options": [
        "Tropisch",
        "Gematigd",
        "Polair",
        "Woestijn"
      ],
      "correctAnswer": 0,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van interpretatie",
            "region": "interpretatie",
            "highlight": "klimaat_zones"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Klimaatzones",
            "content": "Rond de evenaar: tropisch klimaat (warm en veel regen). Tussen keerkringen en poolcirkels: gematigd klimaat. Rond de polen: polair klimaat.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "climate_zones_tropical",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Koppel klimaatzones aan breedtegraden, van evenaar naar pool. Rond de evenaar (0° breedte) ligt de tropische zone. Kenmerken: het hele jaar warm (25–30 °C) en veel neerslag, met tropisch regenwoud. De volgorde van evenaar naar pool is: tropisch → subtropisch → gematigd → polair. Hoe dichter bij de evenaar, hoe meer zonlicht en warmte.",
        "solutionSteps": [
          "Rond de evenaar (0° breedte) ligt de tropische zone",
          "Kenmerken: het hele jaar warm (25–30 °C) en veel neerslag",
          "De volgorde van evenaar naar pool: tropisch → subtropisch → gematigd → polair",
          "Hoe dichter bij de evenaar, hoe meer zonlicht en warmte"
        ],
        "distractorExplanations": {
          "0": "Correct! Het tropische klimaat ligt rond de evenaar, met warmte en veel regen het hele jaar door.",
          "1": "Het gematigde klimaat ligt tussen de keerkringen en de poolcirkels, zoals Nederland op ~52° NB. Rond de evenaar is het tropisch — veel warmer en natter dan gematigd.",
          "2": "Het polaire klimaat ligt rond de polen (Noord- en Zuidpool), het verst van de evenaar. Rond de evenaar is het juist tropisch — het tegenovergestelde van polair.",
          "3": "Woestijnklimaat komt voor op specifieke breedtegraden rond de keerkringen (~23° NB/ZB), niet rond de evenaar zelf. Rond de evenaar valt juist veel regen, wat tropisch klimaat oplevert."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-001-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Gematigd"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-001-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Polair"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-001-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Woestijn"
          }
        ]
      }
    },
    {
      "id": "TOPO-KLIMAAT-002",
      "familyId": "TOPO-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "interpretatie",
      "subSkill": "klimaat_zones",
      "questionType": "multiple_choice",
      "question": "In welke klimaatzone ligt Nederland?",
      "context": null,
      "options": [
        "Gematigd",
        "Tropisch",
        "Polair",
        "Subtropisch"
      ],
      "correctAnswer": 0,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van interpretatie",
            "region": "interpretatie",
            "highlight": "klimaat_zones"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Gematigd klimaat",
            "content": "Nederland ligt in de gematigde klimaatzone: vier seizoenen, gematigde temperaturen, het hele jaar door regen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "climate_zones_temperate",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Bepaal de klimaatzone aan de hand van breedtegraad en kenmerken. Nederland ligt op ~52° noorderbreedte, tussen de keerkring van Kreeft (~23° NB) en de poolcirkel (~66° NB). Dit is de gematigde zone, met vier seizoenen, milde winters en koele zomers. De Golfstroom en de Noordzee zorgen voor een zeeklimaat — zachter dan landen op dezelfde breedtegraad in het binnenland.",
        "solutionSteps": [
          "Nederland ligt op ~52° noorderbreedte",
          "Dat is tussen de keerkring (~23° NB) en de poolcirkel (~66° NB)",
          "Dit gebied heeft een gematigd klimaat met vier seizoenen",
          "De Golfstroom en Noordzee zorgen voor een mild zeeklimaat"
        ],
        "distractorExplanations": {
          "0": "Correct! Nederland ligt in de gematigde klimaatzone, op ~52° noorderbreedte.",
          "1": "Het tropische klimaat ligt rond de evenaar (0–23° NB/ZB) met temperaturen van 25–30 °C het hele jaar. Nederland op 52° NB is veel koeler en heeft vier seizoenen — dat is gematigd klimaat.",
          "2": "Het polaire klimaat ligt rond de polen, boven ~66° NB. Nederland ligt op 52° NB — ver van de poolcirkel. Het klimaat is gematigd, niet polair.",
          "3": "Het subtropische klimaat (rond 23–35° NB) heeft hete, droge zomers en milde winters, denk aan Spanje of Italië. Nederland op 52° NB ligt noordelijker en heeft een gematigd klimaat."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Tropisch"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-002-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Polair"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-002-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Subtropisch"
          }
        ]
      }
    },
    {
      "id": "TOPO-KLIMAAT-003",
      "familyId": "TOPO-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "interpretatie",
      "subSkill": "klimaat_zones",
      "questionType": "multiple_choice",
      "question": "Welk klimaat heeft de minste neerslag?",
      "context": null,
      "options": [
        "Woestijnklimaat",
        "Tropisch klimaat",
        "Gematigd klimaat",
        "Polair klimaat"
      ],
      "correctAnswer": 0,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.7,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van interpretatie",
            "region": "interpretatie",
            "highlight": "klimaat_zones"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Neerslag per klimaat",
            "content": "Woestijnklimaat: minder dan 250 mm neerslag per jaar (minste). Tropisch klimaat: veel neerslag. Gematigd klimaat: regelmatig neerslag. Polair klimaat: weinig neerslag, maar meer dan woestijn.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "climate_zones_precipitation",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Vergelijk de neerslagcijfers per klimaattype. Woestijnklimaat heeft minder dan 250 mm neerslag per jaar — dat is het minst van alle klimaattypes. Ter vergelijking: Nederland (gematigd) krijgt ~800 mm en tropisch regenwoud krijgt 2000+ mm per jaar. Het polaire klimaat heeft ook weinig neerslag (~200 mm), maar woestijnklimaat is officieel het droogst.",
        "solutionSteps": [
          "Woestijnklimaat: minder dan 250 mm neerslag per jaar (het minst)",
          "Gematigd klimaat (Nederland): ~800 mm per jaar",
          "Tropisch klimaat: 2000+ mm per jaar (het meest)",
          "Polair klimaat: ~200 mm, maar woestijn is officieel het droogst"
        ],
        "distractorExplanations": {
          "0": "Correct! Het woestijnklimaat heeft de minste neerslag, minder dan 250 mm per jaar.",
          "1": "Het tropische klimaat heeft juist de meeste neerslag — tropisch regenwoud krijgt 2000+ mm per jaar. Woestijnklimaat heeft de minste neerslag.",
          "2": "Het gematigde klimaat, zoals in Nederland (~800 mm per jaar), heeft regelmatig neerslag door het hele jaar. Woestijnklimaat (minder dan 250 mm) is veel droger.",
          "3": "Het polaire klimaat heeft inderdaad weinig neerslag (~200 mm, vooral sneeuw), maar het woestijnklimaat is officieel het droogst. Sommige woestijnen krijgen minder dan 25 mm per jaar."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-003-OPT1",
            "optionIndex": 1,
            "label": "Woestijnklimaat heeft de minste neerslag"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-003-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Gematigd klimaat"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-003-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Polair klimaat"
          }
        ]
      }
    },
    {
      "id": "TOPO-KLIMAAT-004",
      "familyId": "TOPO-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "interpretatie",
      "subSkill": "klimaat_zones",
      "questionType": "multiple_choice",
      "question": "Welke factor bepaalt het MEEST welke klimaatzone een gebied heeft?",
      "context": null,
      "options": [
        "De afstand tot de evenaar",
        "De hoogte van de bergen",
        "Het aantal rivieren",
        "De grootte van het land"
      ],
      "correctAnswer": 0,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.71,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van interpretatie",
            "region": "interpretatie",
            "highlight": "klimaat_zones"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Breedtegraad en klimaat",
            "content": "De breedtegraad (afstand tot de evenaar) is de belangrijkste factor voor het klimaat. Dicht bij de evenaar = warm (tropisch). Ver van de evenaar = koud (polair). Daartussen = gematigd. Hoogte en zee beïnvloeden het klimaat ook, maar minder dan breedtegraad.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "climate_latitude_factor",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Onderscheid hoofdfactoren van bijfactoren bij klimaat. De breedtegraad (afstand tot de evenaar) is de belangrijkste factor — die bepaalt hoeveel zonlicht een gebied ontvangt. Dicht bij de evenaar betekent veel zonlicht en warmte (tropisch). Ver van de evenaar betekent weinig zonlicht en kou (polair). Bijfactoren zijn: hoogteligging, nabijheid van zee en zeestromingen.",
        "solutionSteps": [
          "De breedtegraad bepaalt hoeveel zonlicht een gebied ontvangt",
          "Dicht bij de evenaar = veel zonlicht = warm (tropisch)",
          "Ver van de evenaar = weinig zonlicht = koud (polair)",
          "Bijfactoren: hoogteligging, nabijheid van zee, zeestromingen (zoals de Golfstroom)"
        ],
        "distractorExplanations": {
          "0": "Correct! De breedtegraad (afstand tot de evenaar) is de belangrijkste factor voor de klimaatzone.",
          "1": "Bergen beïnvloeden het lokale klimaat (hoger = kouder, regenschaduw), maar de breedtegraad bepaalt de klimaatzone. Bergen zijn een bijfactor, geen hoofdfactor.",
          "2": "Rivieren hebben nauwelijks invloed op de klimaatzone. Ze zijn een gevolg van neerslag, niet een oorzaak van klimaat. De breedtegraad is de hoofdfactor.",
          "3": "De grootte van een land bepaalt niet de klimaatzone — Rusland is enorm groot maar heeft meerdere klimaatzones (van polair tot gematigd). De breedtegraad is de hoofdfactor."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-004-OPT1",
            "optionIndex": 1,
            "label": "Bergen zijn een bijfactor, geen hoofdfactor"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-004-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Het aantal rivieren"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-004-OPT3",
            "optionIndex": 3,
            "label": "De breedtegraad is de hoofdfactor"
          }
        ]
      }
    },
    {
      "id": "TOPO-KLIMAAT-005",
      "familyId": "TOPO-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "interpretatie",
      "subSkill": "klimaat_zones",
      "questionType": "multiple_choice",
      "question": "Welk kenmerk hoort bij het poolklimaat?",
      "context": null,
      "options": [
        "Het hele jaar door temperaturen onder 0°C",
        "Vier duidelijke seizoenen",
        "Veel regen en hoge temperaturen",
        "Droog met grote temperatuurverschillen"
      ],
      "correctAnswer": 0,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van interpretatie",
            "region": "interpretatie",
            "highlight": "klimaat_zones"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Poolklimaat",
            "content": "Het poolklimaat (polair klimaat) komt voor rond de Noord- en Zuidpool. Kenmerken: het hele jaar door koud (onder 0°C), weinig neerslag (sneeuw), lange donkere winters en korte zomers.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "climate_polar_characteristics",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Koppel elk klimaattype aan zijn kenmerkende eigenschappen. Het poolklimaat (polair) komt voor boven de poolcirkels (~66° NB/ZB). Het hoofdkenmerk is dat de temperaturen het hele jaar door onder of rond 0 °C liggen. Overige kenmerken: weinig neerslag (vooral sneeuw), lange donkere winters (poolnacht), korte zomers (middernachtzon) en permafrost in de bodem.",
        "solutionSteps": [
          "Het poolklimaat komt voor boven de poolcirkels (~66° NB/ZB)",
          "Hoofdkenmerk: temperaturen het hele jaar door onder of rond 0 °C",
          "Weinig neerslag, vooral in de vorm van sneeuw",
          "Lange donkere winters (poolnacht) en korte zomers (middernachtzon)"
        ],
        "distractorExplanations": {
          "0": "Correct! Bij het poolklimaat zijn de temperaturen het hele jaar door onder 0 °C.",
          "1": "Vier duidelijke seizoenen horen bij het gematigde klimaat, zoals in Nederland. Bij het poolklimaat is het het hele jaar koud — er zijn geen echte seizoenen zoals wij die kennen.",
          "2": "Veel regen en hoge temperaturen horen bij het tropische klimaat rond de evenaar. Het poolklimaat is het tegenovergestelde: koud en droog.",
          "3": "Droog met grote temperatuurverschillen tussen dag en nacht hoort bij het woestijnklimaat. Het poolklimaat is ook droog, maar de temperatuur is constant laag (onder 0 °C)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-005-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Vier duidelijke seizoenen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-005-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Veel regen en hoge temperaturen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-KLIMAAT-005-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Droog met grote temperatuurvers"
          }
        ]
      }
    }
  ]
}